import { Box } from "@mui/material";
import React from "react";
import BoxLayout from "../../common/components/Layout/BoxLayout";
import { PRIMARY, WHITE } from "../colors";
import MailOutlineIcon from "@mui/icons-material/MailOutline";

const PageContainer = (props) => {
  const {
    title,
    content,
    boxTitle,
    toolbarAction,
    contentClassName,
    children,
  } = props;
  return (
    <Box className="w-full">
      <Box
        className="box-border w-full py-10 h-60 px-15 "
        style={{ backgroundColor: PRIMARY, color: WHITE }}
      >
        <Box className="flex items-center">
          <MailOutlineIcon className="mr-4" />

          <b className="text-[18px]">{title}</b>
        </Box>
      </Box>
      <Box className="mx-15" style={{ marginTop: -60 }}>
        <BoxLayout
          pageTitle={boxTitle}
          toolbarAction={toolbarAction}
          content={content || children}
          contentClassName={contentClassName}
        />
      </Box>
    </Box>
  );
};

export default PageContainer;
